import React, { useState } from 'react';
import { Switch, Route } from 'react-router-dom';
// import { useSelector } from 'react-redux';

// import HomePage from './container/Reservation/ReservationContainer';
import LoginContainer from './container/Unit/LoginContainer';
import ReservationContainer from './container/Reservation/ReservationContainer';
import MakeRoomContainer from './container/MakeRoom';
import CompanyContainer from './container/Company';
import GuestInformationContainer from './container/GuestInformation';
import CancelAreaContainer from './container/CancelArea';
import WaitingAreaContainer from './container/WaitingArea';
import MakeBookingBill from './container/MakeBookingBill';
import AddServiceOnBooking from './container/MakeHotelInvoice/AddServiceOnBooking';
import MakeServiceInvoice from './container/MakeHotelInvoice/MakeServiceInvoice';
import ManagerServiceInvoice from './container/ManagerServiceInvoice/ManagerServiceInvoice';
import MakeHotelInvoice from './container/MakeHotelInvoice/MakeHotelInvoice';
import InvoiceManagerContainer from './container/Invoice';
import ViewPdf from './container/Unit/ViewPdf';
import GlistContainer from './container/Glist/GlistContainer';
import SupportReportContainer from './container/SupportReport';
import GuestNumberContainer from './container/Unit/SupportTools/GuestNumber/GuestNumberContainer';
import GuestCheckInContainer from './container/Unit/SupportTools/GuestCheckIn/GuestCheckInContainer';
import MakePMMRQContainer from './container/MakePMRQ';
import FightManageContainer from './container/FlightManage';
import GuestCheckInManageContainer from './container/GuestCheckInManage';
import GuestCheckOutAccContainer from './container/Unit/SupportTools/GuestCheckOut/GuestCheckOutAccContainer';
import MailContainer from './container/MailContainer';
import MakeServiceBill from './container/MakeServiceBill';
import CompanyEditHistory from './components/Company/companyHistory';
import SetupPromotion from './container/Unit/SupportTools/SetupPromotion/SetupPromotion';

import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import MakeBookingBillDemo1 from './container/MakeBookingBill/demoBooking1';
import MakePickUpBoardDemo from './components/MakeRoom/MakeRoomDataRoom/makePickUpBoardDemo';
import MakeBookingBillDemo2 from './container/MakeBookingBill/demoBooking2';
import PictureSIContainer from './container/SupportTool/RC/PictureSIContainer';
import MembershipGude from './container/SupportTool/RC/MembershipGude';
import MembershipResult from './container/SupportTool/Other/MembershipResult ';
import RealtimeAdminContainer from './container/RealtimeAdmin';
import PromotionContainer from './container/Promotion/PromotionContainer';
import SaleRomOnWebsite from './container/Unit/SupportTools/SaleRomOnWebsite/SaleRomOnWebsite';
import SettingDatabase from './container/SupportTool/Other/SettingDatabase';
import StatisticsData from './container/SupportTool/Other/StatisticsData';
import ViewImagePage from './components/Unit/SupportTools/ViewImagePage';

function NewRouter(props) {
    //const auth = useSelector(state => state.auth);
    // const { isLoggedIn, } = auth;
    const token = useSelector(state => state.token);
    const firstLogin = localStorage.getItem('firstLogin');
    const [isAccess, setIsAccess] = useState(true);
    const [countLoad, setCoundLoad] = useState(0);

    const location = useLocation();

    useEffect(() => {
        if(location.pathname === "/" || location.pathname === "/login") {
            if(firstLogin)  setIsAccess(true);
        } else {
            if(firstLogin) {
                setIsAccess(true);
                if(token) {
                    setIsAccess(true);
                } else {
                    setCoundLoad(countLoad+1)

                    if (location.pathname.includes("/make_booking_bill") || location.pathname.includes("/make_invoice") ) {
                        const parts = location.pathname.split("/");
                        const branchID = parts[2];
                        if(Number(branchID) < 100) {
                            if (countLoad === 1000000) {
                                window.location.href = "/";
                            }
                        } else {
                            window.location.href = "/";
                        }
                    } else {
                        if (countLoad === 100000) {
                            window.location.href = "/";
                        }
                    }
                }
            } else  {
             window.location.href = "/"
            }
        }
    },[countLoad, firstLogin, location.pathname, token])

    // useLayoutEffect(() => {
    //     setTimeout(() => {
    //     }, 5000);
    // }, [])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    // const checkLogin = useCallback(() => {
    //     if (!firstLogin) return LoginContainer;
    //     else return !isLoggedIn ? LoginContainer : "";
    //     // HomePage
    // })

    return (
        <section style={{ margin: 'auto',width:'maxContent'}}>
            <Switch>
                {/* <Route path="/user/profile" component={!isLoggedIn ? NotFound : ProfileContainer} exact /> */}
                <Route path="/" component={LoginContainer} exact />
                <Route path="/login" component={LoginContainer} exact />
                {/* <Route path="/home" component={isAccess && ReservationContainer} exact /> */}
                <Route path="/cancel" component={isAccess && CancelAreaContainer} exact />
                <Route path="/glist" component={isAccess && GlistContainer} exact />
                <Route path="/glist/:branchID/:day" component={isAccess && GlistContainer} exact />
                <Route path="/invoice" component={isAccess && InvoiceManagerContainer} exact />
                <Route path="/flight" component={isAccess && FightManageContainer} exact />
                <Route path="/checkin" component={isAccess && GuestCheckInManageContainer} exact />
                <Route path="/invoice/:month" component={isAccess && InvoiceManagerContainer} exact />
                <Route path="/viewPDF/:branch/:link" component={isAccess && ViewPdf} exact />
                <Route path="/waiting" component={isAccess && WaitingAreaContainer} exact />
                <Route path="/make_booking_bill/:branchID/:idRoom" component={ isAccess && MakeBookingBillDemo1} exact />
                <Route path="/make_booking_bill/:branchID/:type/:idRoom" component={ isAccess && MakeBookingBillDemo1} exact />
                
                <Route path="/make_booking_bill_demo/:branchID/:idRoom" component={ isAccess && MakeBookingBillDemo2} exact />
                <Route path="/make_booking_bill_old/:branchID/:idRoom" component={ isAccess && MakeBookingBill} exact />
                <Route path="/make_booking_bill_old/:branchID/:type/:idRoom" component={ isAccess && MakeBookingBill} exact />
                {/* <Route path="/make_booking_bill_old2/:branchID/:idRoom" component={ isAccess && MakeBookingBillDemo1} exact />
                <Route path="/make_booking_bill_old2/:branchID/:type/:idRoom" component={ isAccess && MakeBookingBillDemo1} exact /> */}

                <Route path="/make_service_bill/:branchID/:idRoom" component={ isAccess && MakeServiceBill} exact />

                <Route path="/reservation" component={isAccess && ReservationContainer} exact /> 
                <Route path="/reservation/:branchIDParam/:month" component={isAccess && ReservationContainer} exact />

                <Route path="/reservation_test" component={isAccess && ReservationContainer} exact />
                <Route path="/reservation_test/:branchIDParam/:month" component={isAccess && ReservationContainer} exact />

                <Route path="/reservation_test2" component={isAccess && ReservationContainer} exact />
                <Route path="/reservation_test2/:branchIDParam/:month" component={isAccess && ReservationContainer} exact />

                <Route path="/add_service/:branchID/:idRoom" component={ isAccess && AddServiceOnBooking} exact />
                <Route path="/manage-service_invoice" render={ isAccess ? () => <ManagerServiceInvoice /> : () => null} exact />
                <Route path="/service_invoice" render={ isAccess ? () => <MakeServiceInvoice /> : () => null} exact />
                <Route path="/service_invoice/:branchID/:idRoom/:version" render={ isAccess ? () => <MakeServiceInvoice /> : () => null} exact />
                <Route path="/service_invoice/:branchID/:idRoom" render={ isAccess ? () => <MakeServiceInvoice /> : () => null} exact />
                <Route path="/setting_database" component = {SettingDatabase} exact />
                <Route path="/statistics" component = {isAccess  && StatisticsData} exact />
                    {/* && ( (isAM || isAdmin)) */}
                <Route path="/make_pmrq/:branchID/:idRoom" component={ isAccess && MakePMMRQContainer} exact />
                <Route path="/make_pmrq/:branchID/:type/:idRoom" component={ isAccess && MakePMMRQContainer} exact />
                <Route path="/make_invoice/:branchID/:idRoom" component={ isAccess && MakeHotelInvoice} exact />
                <Route path="/make_invoice/:branchID/:type/:idRoom" component={MakeHotelInvoice} exact />
                {/* <Route path="/daily-report" component={isAccess && ReservationContainer} exact /> */}

                <Route path="/room" component={isAccess && MakeRoomContainer} exact />
                <Route path="/room/:branchID/:roomSelect/:checkin" component={isAccess && MakeRoomContainer} exact />
                <Route path="/room/:branchID/:idRoom" component={isAccess && MakeRoomContainer} exact />

                <Route path="/room_history/:branchID/:id_history" component={isAccess && MakeRoomContainer} exact />
                <Route path="/check_room/:branchID/:idRoom/:typeRoom" component={MakeRoomContainer} exact />
                <Route path="/company" component={isAccess && CompanyContainer} exact />
                <Route path="/company_history/:id" component={isAccess && CompanyEditHistory} exact />

                <Route path="/guest" component={isAccess && GuestInformationContainer} exact />
                <Route path="/mail" component={isAccess && MailContainer} exact />
                <Route path="/picture-si" component={isAccess && PictureSIContainer} exact />
                <Route path="/membership-guide" component={isAccess && MembershipGude} exact />
                <Route path="/update-guide" component={isAccess && MembershipGude} exact />
                <Route path="/return_az_coin" component={isAccess && MembershipResult} exact />
                <Route path="/realtime-admin" component={isAccess && RealtimeAdminContainer} exact />
                <Route path="/az-storage/image/:name" component={isAccess && ViewImagePage} exact />

                <Route path="/make_pick_up_file/:branchID/:idRoom" component={MakePickUpBoardDemo} exact />

                <Route path="/guest/:id" component={isAccess && GuestInformationContainer} exact />
                <Route path="/report" component={isAccess && SupportReportContainer} exact />
                <Route path="/promotion" component = {isAccess && PromotionContainer} exact />
                {/* Support Tools */}
                <Route path="/guest_number" component={isAccess && GuestNumberContainer} exact />
                <Route path="/sale_room_on_website" component = {isAccess && SaleRomOnWebsite} exact />
                <Route path="/setup_promotion" component={isAccess && SetupPromotion} exact />
                <Route path="/guest_checkin" component={isAccess && GuestCheckInContainer} exact />
                <Route path="/guest_checkout" component={isAccess && GuestCheckOutAccContainer} exact />
            </Switch>
        </section>
    );
}

export default NewRouter;